import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=0da7fd4d&scoped=true"
import script from "./Card.vue?vue&type=script&lang=ts"
export * from "./Card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da7fd4d",
  null
  
)

export default component.exports